














import { Component, Prop, Vue } from 'vue-property-decorator';
import YcColorPicker from '@/components/color-picker/index.js';
import PopField from '../PopField/index.vue';
import { predefineColors } from '@/views/wheelOfFortune/constant/options';

@Component({ components: { PopField, 'yc-color-picker': YcColorPicker } })
export default class ColorField extends Vue {
  @Prop({ type: String, default: '' }) value!: string;
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: String, default: '' }) col!: string;
  @Prop({ type: Boolean, default: false }) showAlpha!: boolean;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: Array, default: null }) predefine!: string[] | null;
  predefineColors = predefineColors;
}
